import { Mars, NonBinary, Venus } from "lucide-react";

export const defaultDarkModeLogo = "./logos/simple-crm-final-dark.svg";
export const defaultLightModeLogo = "./logos/simple-crm-final.svg";

export const defaultTitle = "SimpleCRM";

export const defaultCompanySectors = [
  "Serviços de Comunicação",
  "Consumo Discricionário",
  "Bens de Consumo Essenciais",
  "Energia",
  "Serviços Financeiros",
  "Cuidados de Saúde",
  "Industriais",
  "Tecnologia da Informação",
  "Materiais",
  "Imóveis",
  "Utilidades Públicas",
];

export const defaultDealStages = [
  { value: "opportunity", label: "Oportunidade" },
  { value: "proposal-sent", label: "Proposta Enviada" },
  { value: "in-negociation", label: "Em Negociação" },
  { value: "won", label: "Ganho" },
  { value: "lost", label: "Perdido" },
  { value: "delayed", label: "Atrasado" },
];

export const defaultDealPipelineStatuses = ["won"];

export const defaultDealCategories = [
  "Outro",
  "Redação",
  "Projeto Gráfico",
  "Design de Interface",
  "Design de Website",
];

export const defaultNoteStatuses = [
  { value: "cold", label: "Frio", color: "#7dbde8" },
  { value: "warm", label: "Esquentar", color: "#e8cb7d" },
  { value: "hot", label: "Quente", color: "#e88b7d" },
  { value: "in-contract", label: "Em contrato", color: "#a4e87d" },
];

export const defaultTaskTypes = [
  "Nenhum",
  "Email",
  "Demonstração",
  "Almoço",
  "Reunião",
  "Acompanhamento",
  "Agradecimento",
  "Envio",
  "Ligação",
];

export const defaultContactGender = [
  { value: "male", label: "Ele/Dele", icon: Mars },
  { value: "female", label: "Ela/Dela", icon: Venus },
  { value: "nonbinary", label: "Elu/Delu", icon: NonBinary },
];
